import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPythonLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9279 2C6.85066 2 7.16772 4.2018 7.16772 4.2018L7.17338 6.48285H12.0185V7.16772H5.24894C5.24894 7.16772 2 6.79925 2 11.9223C2 17.0452 4.83574 16.8636 4.83574 16.8636H6.52813V14.4863C6.52813 14.4863 6.43691 11.6506 9.31857 11.6506C12.2003 11.6506 14.124 11.6506 14.124 11.6506C14.124 11.6506 16.8239 11.6942 16.8239 9.04122C16.8239 6.38825 16.8239 4.65461 16.8239 4.65461C16.8239 4.65461 17.2339 2 11.9279 2ZM9.25632 3.5339C9.73838 3.5339 10.128 3.92351 10.128 4.40556C10.128 4.88762 9.73838 5.27722 9.25632 5.27722C8.77425 5.27722 8.38466 4.88762 8.38466 4.40556C8.38466 3.92351 8.77425 3.5339 9.25632 3.5339Z",
			fill: "url(#paint0_linear_760_3599)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0721 21.8959C17.1493 21.8959 16.8323 19.6941 16.8323 19.6941L16.8266 17.413H11.9815V16.7281H18.7511C18.7511 16.7281 22 17.0966 22 11.9736C22 6.85063 19.1643 7.03229 19.1643 7.03229H17.4719V9.40957C17.4719 9.40957 17.5631 12.2453 14.6814 12.2453C11.7997 12.2453 9.87597 12.2453 9.87597 12.2453C9.87597 12.2453 7.17606 12.2017 7.17606 14.8546C7.17606 17.5076 7.17606 19.2413 7.17606 19.2413C7.17606 19.2413 6.76615 21.8959 12.0721 21.8959ZM14.7437 20.362C14.2616 20.362 13.872 19.9724 13.872 19.4903C13.872 19.0082 14.2616 18.6186 14.7437 18.6186C15.2257 18.6186 15.6153 19.0082 15.6153 19.4903C15.6153 19.9724 15.2257 20.362 14.7437 20.362Z",
			fill: "url(#paint1_linear_760_3599)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_760_3599",
			x1: 3.92204,
			y1: 3.73908,
			x2: 13.8115,
			y2: 13.6616,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#387EB8" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#366994"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_760_3599",
			x1: 10.0056,
			y1: 10.0513,
			x2: 20.6268,
			y2: 20.227,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE052" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FFC331"
			})]
		})] })
	]
});
export { SvgIconPythonLogo as ReactComponent };
